import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const Home = lazy(() => import('./Home'));
const MangaList = lazy(() => import('./MangaList'));

const App = () => (
  <Router>
    {/* Suspense vai fazer code-split e carregar cada rota sob demanda */}
    <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '2rem' }}>Carregando...</div>}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/listadeleitura" element={<MangaList />} />
      </Routes>
    </Suspense>
  </Router>
);

export default App;
